import { FormInstance } from 'antd';

export const formScrollToFieldOnError = (form: FormInstance, error: any) => {
  if (error && typeof error === 'object' && 'errorFields' in error && Array.isArray(error.errorFields)) {
    form.scrollToField(error.errorFields[0].name, {
      block: 'center',
    });
  }
};

/**
 * Maps a Laravel 422 payload (`{ errors: { field: [message] } }`) onto the matching
 * form fields. Returns `false` when the error is not a validation error, so the
 * caller can fall back to the generic error handler.
 */
export const setFormErrorsFromResponse = (form: FormInstance, error: any): boolean => {
  const errors = error?.response?.status === 422 ? error?.response?.data?.errors : undefined;
  const fields = Object.keys(errors ?? {});

  if (fields.length === 0) return false;

  form.setFields(fields.map((name) => ({ name, errors: errors[name] })));

  return true;
};
